<template>
    <div class="adv-progress">
        <div class="adv-progress-bar">
            <span
                class="adv-progress-bar__inner"
                :style="{ width: progress }"
            ></span>
        </div>
        <p class="adv-progress__label">{{ progress }}</p>
    </div>
</template>
<script>
export default {
    name: 'AdvProgress',
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    computed: {
        progress({ value }) {
            return Math.round(+value) + '%';
        }
    }
};
</script>

<style lang="scss">
.adv-progress {
    width: 100%;
    display: flex;
    height: 20px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    .adv-progress-bar {
        height: 10px;
        flex: 1;
        background: #ebecf1;
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        .adv-progress-bar__inner {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            border-radius: 20px;
            background: #4c84ff;
        }
    }
    .adv-progress__label {
        width: 50px;
        font-size: 14px;
        color: #4c84ff;
        text-align: right;
    }
}
</style>
